<template>
    <div v-if="model" style="position: relative">
        <div class="info">
            <router-link :to="'/'+folder+'/'+model.ID_Model">
                <h1>
                    {{ model.Voornaam }} {{ model.Achternaam_letter }}
                </h1>
            </router-link>
            <table class="model-preview-data">
                <tr>
                    <td>{{ trans('talents.profile.age') }}</td>
                    <td>: {{ model.Leeftijd }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.length') }}</td>
                    <td>: {{ model.Lengte }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.ready_to_wear') }}</td>
                    <td>: {{ model.Confectie }}</td>
                </tr>
            </table>
            <div v-if="!isFavorite(model.ID_Model)" class="btn-orange add-to-selection" @click.stop="addToFavorites(model.ID_Model)">{{ trans('talents.profile.add_to_selection') }}<span class="plus">+</span></div>
            <div v-if="isFavorite(model.ID_Model)" class="btn-quiet remove-from-selection" @click.stop="removeFromFavorites(model.ID_Model, (mode==='talents' || mode==='proposal'))">{{ trans('talents.profile.delete_from_selection') }} <span class="min">-</span></div>
            <router-link :to="'/'+folder+'/'+model.ID_Model" class="btn-quiet show-model">{{ trans('talents.profile.show_model') }}</router-link>
        </div>
        <div class="images">
            <router-link :to="'/'+folder+'/'+model.ID_Model">
                <picture class="model-image preview-image visible" v-if="!loading && modelfotos[0]">
                    <source :srcset="'/models/'+modelfotos[0].ID_Foto+'.webp'" type="image/webp">
                    <source :srcset="'/models/'+modelfotos[0].ID_Foto+'.jpg'" type="image/jpeg">
                    <img class="lazy" style="width:100%;min-height: 270px;" src="/assets/images/nix.gif" :data-src="'/models/'+modelfotos[0].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter">
                </picture>
                <picture class="model-image preview-image visible" v-if="!loading && modelfotos[1]">
                    <source :srcset="'/models/'+modelfotos[1].ID_Foto+'.webp'" type="image/webp">
                    <source :srcset="'/models/'+modelfotos[2].ID_Foto+'.jpg'" type="image/jpeg">
                    <img class="lazy" style="width:100%;min-height: 270px;" src="/assets/images/nix.gif" :alt="model.Voornaam +' '+model.Achternaam_letter">
                </picture>
                <picture class="model-image preview-image visible" v-if="!loading && modelfotos[2]">
                    <source :srcset="'/models/'+modelfotos[2].ID_Foto+'.webp'" type="image/webp">
                    <source :srcset="'/models/'+modelfotos[2].ID_Foto+'.jpg'" type="image/jpeg">
                    <img class="lazy" style="width:100%;min-height: 270px;" src="/assets/images/nix.gif" :data-src="'/models/'+modelfotos[2].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter">
                </picture>
                <picture class="model-image preview-image visible" v-if="!loading && modelfotos[3]">
                    <source :srcset="'/models/'+modelfotos[3].ID_Foto+'.webp'" type="image/webp">
                    <source :srcset="'/models/'+modelfotos[3].ID_Foto+'.jpg'" type="image/jpeg">
                    <img class="lazy" style="width:100%;min-height: 270px;" src="/assets/images/nix.gif" :data-src="'/models/'+modelfotos[3].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter">
                </picture>
                <picture class="model-image preview-image visible" v-if="!loading && modelfotos[4]">
                    <source :srcset="'/models/'+modelfotos[4].ID_Foto+'.webp'" type="image/webp">
                    <source :srcset="'/models/'+modelfotos[4].ID_Foto+'.jpg'" type="image/jpeg">
                    <img  class="lazy" style="width:100%;min-height: 270px;" src="/assets/images/nix.gif" :data-src="'/models/'+modelfotos[4].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter">
                </picture>
            </router-link>
        </div>
    </div>
</template>
<script type='text/babel'>
import {mapState} from 'vuex'

export default {
    props: ['index'],
    data: function () {
        return {
            loading: false,
        }
    },
    mounted() {
        this.loading = true
        setTimeout(function () {
            this.loading = false
        }.bind(this), 300)
    },
    watch: {
        index: function () {
            this.loading = true
            setTimeout(function () {
                this.loading = false
            }.bind(this), 300)
        }
    },
    computed: {
        ...mapState(['models']),
        ...mapState(['favorites']),
        folder() {
            return this.mode === 'favorites' ? 'model' : 'model'
        },
        mode() {
            return this.$store.getters.mode()
        },
        currentList() {
            return this.list === 'favorites' ? this.favorites[this.project] : this.models
        },
        model() {
            return this.currentList[this.index]
        },
        modelfotos() {
            return _.uniqBy(_.toArray(this.model.fotos), 'id')
        },
        proposalId() {
            return this.$store.getters.proposalId()
        }
    },
    methods: {
        showImage(event) {
            event.target.classList.add('justloaded')
            event.target.classList.add('visible')
        },
    },
}
</script>
